// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { rem } from "polished";
import styled from "styled-components";

import { palette, spacing, typography } from "~design-system";

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: ${rem(spacing.sm)};
`;

export const BackRow = styled.div`
  align-items: center;
  display: flex;
  min-height: ${rem(48)};
`;

const ICON_SLOT_SIZE = 40;

export const TitleRow = styled.div`
  align-items: center;
  display: flex;
  gap: ${rem(spacing.sm)};
`;

export const IconSlot = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: ${rem(ICON_SLOT_SIZE)};
  justify-content: center;
  width: ${rem(ICON_SLOT_SIZE)};
`;

export const Title = styled.h1`
  ${typography.Serif24}

  color: ${palette.pine2};
  margin: 0;
`;

export const Intro = styled.p`
  ${typography.Sans16}

  color: ${palette.pine2};
  margin: 0;
`;
